import { SubscriptionType } from '@farmersdog/lead-browser-storage';

import type { AttributesContextualInfo } from '../types';

export function getIsDiy(context: AttributesContextualInfo) {
  return context.currentSignupSubscriptionType === SubscriptionType.Diy;
}
